/*
  LOULOUIS · Kommer snart (siden) v1.3
  Viser smykkene med «Åpner for alle» som en oversikt i to deler:
  kommende slipp (snarest først) og nylig kommet (nyest først).
  Kortene viser «Kommer 21.10 kl. 20» til smykket kommer.
  Toppen (litt Djerf Avenue): dato, overskrift, nedtelling og påmelding til alle slipp
  rett i boksen, uten eget vindu.
  Ett slipp er alle smykker med nøyaktig samme dato og klokkeslett.
  I hvert slipp står gull og sølv av samme smykke ved siden av hverandre, gull først.
  Teller ned, åpner smykkene live når tiden er inne, og håndterer venteliste og handlekurv.
  Krever ll-slipp.js (lastes i ll-slipp-head eller av seksjonen selv).
*/
(function () {
  'use strict';

  function boot() {
    var L = window.LLSlipp;
    if (!L || !L.ready) {
      /* Motoren er ikke lastet ennå. Venter på den. */
      document.addEventListener('ll-slipp:ready', boot, { once: true });
      return;
    }
    if (!L.page) L.page = definePage(L);
    var roots = document.querySelectorAll('[data-ll-ks]');
    for (var i = 0; i < roots.length; i++) L.page.init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var L = window.LLSlipp;
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-ll-ks]') : null;
    if (r && L && L.page) L.page.init(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-ll-ks]') : null;
    if (r && r._llks) r._llks.destroy();
  });

  function definePage(L) {
    var DAY = L.DAY;
    var MIN = L.MIN;
    var setText = L.setText;
    var setHTML = L.setHTML;

    function q(root, sel) { return root.querySelector(sel); }
    function each(list, fn) { Array.prototype.forEach.call(list, fn); }
    function show(el, on) { if (el) el.hidden = !on; }
    function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

    /* «fredag 16. oktober kl. 12.00» blir dato og klokkeslett hver for seg. */
    function when(ms) {
      var s = L.fmtLong(ms);
      var i = s.lastIndexOf(' kl. ');
      return i === -1 ? { date: L.cap(s), time: '' } : { date: L.cap(s.slice(0, i)), time: s.slice(i + 1) };
    }

    /* ---------- KORT ---------- */

    function readCard(el) {
      var vs = q(el, 'script[data-variants]');
      var variants = [];
      if (vs) { try { variants = JSON.parse(vs.textContent) || []; } catch (e) { variants = []; } }
      var open = parseInt(el.getAttribute('data-open'), 10);
      return {
        el: el,
        key: el.getAttribute('data-key'),
        title: el.getAttribute('data-title') || '',
        open: isNaN(open) ? 0 : open * 1000,
        low: el.getAttribute('data-low') === 'true',
        pair: el.getAttribute('data-pair') || '',
        metal: parseInt(el.getAttribute('data-metal'), 10) || 3,
        thumb: el.getAttribute('data-thumb') || '',
        variants: variants,
        badge: q(el, '[data-badge]'),
        notifyBtn: q(el, '[data-notify]'),
        addBtn: q(el, '[data-add]'),
        chooseBtn: q(el, '[data-choose]'),
        soldBtn: q(el, '[data-soldout]'),
        msg: q(el, '[data-msg]'),
        state: null
      };
    }

    function available(c) {
      for (var i = 0; i < c.variants.length; i++) if (c.variants[i].available) return true;
      return false;
    }

    function stateOf(c, t) {
      var st = L.stateFor(c.open, t);
      if ((st === 'open' || st === 'early') && !available(c)) return 'soldout';
      return st;
    }

    function renderCard(S, c, t) {
      var st = c.state;
      var badge = '';
      var label = '';
      var mode = 'notify';

      if (st === 'locked' || st === 'waitlist') {
        badge = L.ICON_LOCK + '<span>Kommer ' + (L.fmtCard ? L.fmtCard(c.open) : L.fmtDate(c.open)) + '</span>';
      } else if (st === 'early') {
        badge = L.DOT + '<span>Tidlig tilgang</span>';
        mode = 'add';
      } else if (st === 'open') {
        if (c.low) badge = '<span>Få igjen</span>';
        else if (c.open && t - c.open < S.recentDays * DAY) { badge = L.ICON_OPEN; label = 'Nylig kommet'; }
        mode = 'add';
      } else if (st === 'soldout') {
        badge = '<span>Utsolgt</span>';
        mode = 'sold';
      }

      if (c.badge && c.badge._b !== badge) {
        c.badge._b = badge;
        setHTML(c.badge, badge);
        var iconOnly = !!badge && badge.indexOf('<span>') === -1;
        c.badge.classList.toggle('is-icon', iconOnly);
        if (iconOnly && label) {
          c.badge.setAttribute('role', 'img');
          c.badge.setAttribute('aria-label', label);
        } else {
          c.badge.removeAttribute('role');
          c.badge.removeAttribute('aria-label');
        }
      }
      c.el.setAttribute('data-state', st);

      show(c.notifyBtn, mode === 'notify');
      if (c.notifyBtn && mode === 'notify') {
        var joined = S.joined.indexOf(c.key) !== -1;
        if (joined !== c.notifyBtn._joined) {
          c.notifyBtn._joined = joined;
          c.notifyBtn.disabled = joined;
          c.notifyBtn.classList.toggle('is-joined', joined);
          if (joined) setHTML(c.notifyBtn, L.ICON_CHECK + '<span>Påmeldt</span>');
          else setText(c.notifyBtn, 'Varsle meg');
        }
      }
      show(c.addBtn, mode === 'add');
      show(c.chooseBtn, mode === 'add');
      show(c.soldBtn, mode === 'sold');
    }

    function celebrate(c) {
      c.el.classList.remove('is-unlocking');
      void c.el.offsetWidth;
      c.el.classList.add('is-unlocking');
      var lock = c.badge ? q(c.badge, '.ll-slipp-lock') : null;
      if (lock) {
        lock.classList.remove('is-open');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { lock.classList.add('is-open'); });
        });
      }
      window.setTimeout(function () { c.el.classList.remove('is-unlocking'); }, 2000);
    }

    /* ---------- RADER (ett slipp per rad) ---------- */

    /* Gull og sølv av samme smykke står ved siden av hverandre, gull først.
       Par kommer først i raden og enkeltsmykker sist. Med partall kolonner
       deles da ingen par over to linjer. */
    function pairUp(cards) {
      var groups = [];
      var byKey = {};
      cards.forEach(function (c, i) {
        c._i = i;
        var k = c.pair || c.key;
        if (!byKey[k]) { byKey[k] = []; groups.push(byKey[k]); }
        byKey[k].push(c);
      });
      var pairs = [];
      var singles = [];
      groups.forEach(function (g) {
        g.sort(function (a, b) { return (a.metal - b.metal) || (a._i - b._i); });
        (g.length > 1 ? pairs : singles).push(g);
      });
      var out = [];
      pairs.concat(singles).forEach(function (g) { out = out.concat(g); });
      return out;
    }

    function regroup(S) {
      var t = L.now();
      var cutoff = t - S.unlockedDays * DAY;
      var rows = {};
      var up = [];
      var rel = [];
      var times = [];

      S.cards.forEach(function (c) {
        c.state = stateOf(c, t);
        if (!c.open) return;
        if (times.indexOf(c.open) === -1) times.push(c.open);
        var released = t >= c.open;
        if (released && c.open < cutoff) return;
        var id = (released ? 'rel:' : 'up:') + c.open;
        if (!rows[id]) {
          rows[id] = { id: id, open: c.open, part: released ? 'released' : 'upcoming', cards: [] };
          (released ? rel : up).push(rows[id]);
        }
        rows[id].cards.push(c);
      });

      up.concat(rel).forEach(function (r) { r.cards = pairUp(r.cards); });
      times.sort(function (a, b) { return a - b; });
      up.sort(function (a, b) { return a.open - b.open; });
      rel.sort(function (a, b) { return b.open - a.open; });
      up.forEach(function (r, i) { r.kind = i === 0 ? 'next' : 'later'; });
      rel.forEach(function (r) { r.kind = 'released'; });

      S.up = up;
      S.rel = rel;
      S.times = times;
      placeRows(S);
    }

    /* Id for raden, så nedtellingen øverst kan lenke rett til slippet. */
    function rowDomId(S, id) { return 'll-ks-' + S.sectionId + '-' + id.replace(':', '-'); }

    /* «Charm armbånd og Love letter charm», «A, B og 3 til».
       Gull og sølv med samme navn telles én gang. */
    function names(cards) {
      var t = [];
      cards.forEach(function (c) { if (t.indexOf(c.title) === -1) t.push(c.title); });
      if (t.length <= 1) return t.join('');
      if (t.length === 2) return t[0] + ' og ' + t[1];
      if (t.length === 3) return t[0] + ', ' + t[1] + ' og ' + t[2];
      return t[0] + ', ' + t[1] + ' og ' + (t.length - 2) + ' til';
    }

    function makeRow(S, id) {
      var el = document.createElement('article');
      el.className = 'll-ks-row';
      el.id = rowDomId(S, id);
      el.setAttribute('data-row', id);
      el.innerHTML =
        '<header class="ll-ks-row__head">' +
        '<div class="ll-ks-row__titles">' +
        '<p class="ll-ks-row__eyebrow" data-r-eyebrow hidden></p>' +
        '<h3 class="ll-ks-row__when"><span class="ll-ks-row__date" data-r-date></span><span class="ll-ks-row__time" data-r-time></span></h3>' +
        '</div>' +
        '<p class="ll-ks-row__status"><span class="ll-ks-row__state" data-r-state></span><span class="ll-ks-row__left" data-r-left></span></p>' +
        '</header>' +
        '<ul class="ll-ks-grid" role="list"></ul>';
      return el;
    }

    function fillPart(S, part, rows, existing) {
      var box = part.rows;
      rows.forEach(function (r) {
        var el = existing[r.id] || makeRow(S, r.id);
        delete existing[r.id];
        el.setAttribute('data-kind', r.kind);
        var list = q(el, '.ll-ks-grid');
        r.cards.forEach(function (c) { list.appendChild(c.el); });
        box.appendChild(el);
      });
      show(part.el, rows.length > 0);
    }

    function placeRows(S) {
      var sig = S.up.concat(S.rel).map(function (r) {
        return r.id + ':' + r.kind + ':' + r.cards.map(function (c) { return c.key; }).join(',');
      }).join('|');
      if (sig === S.sig) return;
      S.sig = sig;

      var shown = {};
      S.up.concat(S.rel).forEach(function (r) { r.cards.forEach(function (c) { shown[c.key] = true; }); });
      S.cards.forEach(function (c) { if (!shown[c.key]) S.pool.appendChild(c.el); });

      var existing = {};
      [S.parts.upcoming, S.parts.released].forEach(function (p) {
        if (!p) return;
        each(p.rows.children, function (el) { existing[el.getAttribute('data-row')] = el; });
      });

      if (S.parts.upcoming) fillPart(S, S.parts.upcoming, S.up, existing);
      if (S.parts.released) fillPart(S, S.parts.released, S.rel, existing);

      Object.keys(existing).forEach(function (k) {
        var el = existing[k];
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      if (S.empty) S.empty.hidden = S.up.length + S.rel.length > 0;
    }

    function countCards(rows) {
      var n = 0;
      rows.forEach(function (r) { n += r.cards.length; });
      return n;
    }

    function renderRows(S, t) {
      S.up.concat(S.rel).forEach(function (r) {
        var el = r.el && r.el.getAttribute('data-row') === r.id ? r.el : null;
        if (!el) {
          var box = S.parts[r.part] ? S.parts[r.part].rows : S.root;
          el = q(box, '[data-row="' + r.id + '"]');
          r.el = el;
        }
        if (!el) return;
        var w = when(r.open);
        var n = S.times.indexOf(r.open) + 1;
        var eyebrow = '';
        var state = '';
        var left = '';
        var inWindow = false;

        if (r.part === 'released') {
          if (S.showNumbers) eyebrow = 'Slipp ' + n;
          state = L.ICON_OPEN + '<span>Ute nå</span>';
          left = plural(r.cards.length, 'smykke', 'smykker');
        } else {
          inWindow = L.EARLY > 0 && t >= r.open - L.EARLY;
          if (r.kind === 'next') eyebrow = S.showNumbers ? 'Neste slipp · Slipp ' + n : 'Neste slipp';
          else if (S.showNumbers) eyebrow = 'Slipp ' + n;
          if (inWindow) {
            state = L.DOT + '<span>' + (S.access ? 'Du har tidlig tilgang' : 'Ventelisten handler nå') + '</span>';
            left = 'Alle om ' + L.fmtLeft(r.open - t);
          } else {
            state = L.ICON_LOCK + '<span>Kommer</span>';
            var x = L.split(r.open - t);
            left = x.d >= 2 ? 'Om ' + x.d + ' dager' : 'Om ' + L.fmtLeft(r.open - t);
          }
        }

        el.setAttribute('data-window', inWindow ? 'true' : 'false');
        var eb = q(el, '[data-r-eyebrow]');
        setText(eb, eyebrow);
        show(eb, !!eyebrow);
        setText(q(el, '[data-r-date]'), w.date);
        setText(q(el, '[data-r-time]'), w.time);
        var stEl = q(el, '[data-r-state]');
        if (stEl._s !== state) { stEl._s = state; setHTML(stEl, state); }
        setText(q(el, '[data-r-left]'), left);
      });

      var nUp = countCards(S.up);
      var nRel = countCards(S.rel);
      if (S.parts.upcoming) setText(S.parts.upcoming.meta, plural(nUp, 'smykke', 'smykker'));
      if (S.parts.released) setText(S.parts.released.meta, plural(nRel, 'smykke', 'smykker'));
      S.nUp = nUp;
      S.nRel = nRel;
    }

    /* Viser hvilket slipp nedtellingen gjelder: bilder, navn og lenke til raden. */
    function renderClockDrop(S, next) {
      var key = next.id + '|' + next.cards.map(function (c) { return c.key; }).join(',');
      if (S.clockKey === key) return;
      S.clockKey = key;
      if (S.clockDrop) S.clockDrop.setAttribute('href', '#' + rowDomId(S, next.id));
      setText(S.clockNames, names(next.cards));
      if (S.clockThumbs) {
        while (S.clockThumbs.firstChild) S.clockThumbs.removeChild(S.clockThumbs.firstChild);
        next.cards.slice(0, 4).forEach(function (c) {
          if (!c.thumb) return;
          var img = document.createElement('img');
          img.src = c.thumb;
          img.alt = '';
          img.width = 32;
          img.height = 32;
          S.clockThumbs.appendChild(img);
        });
        S.clockThumbs.hidden = !S.clockThumbs.firstChild;
      }
    }

    function renderHero(S, t) {
      if (S.clock) {
        var next = S.up.length ? S.up[0] : null;
        if (!next || !S.showClock) {
          S.clock.hidden = true;
          setText(S.clockWhen, '');
          if (S.clockDrop) S.clockDrop.hidden = true;
        } else {
          var open = next.open;
          var inWindow = L.EARLY > 0 && t >= open - L.EARLY;
          S.clock.hidden = false;
          if (S.clockDrop) S.clockDrop.hidden = false;
          renderClockDrop(S, next);
          var label = inWindow
            ? L.DOT + '<span>' + (S.access ? 'Du har tidlig tilgang. Åpner for alle om' : 'Ventelisten handler nå. Åpner for alle om') + '</span>'
            : '<span>Åpner for alle om</span>';
          if (S.clockLabel._l !== label) { S.clockLabel._l = label; setHTML(S.clockLabel, label); }
          var x = L.split(open - t);
          setText(S.dd, L.pad(x.d));
          setText(S.dh, L.pad(x.h));
          setText(S.dm, L.pad(x.m));
          setText(S.ds, L.pad(x.s));
          setText(S.clockWhen, L.cap(L.fmtLong(open)));
          if (S.clockNote) {
            var note = inWindow || !L.EARLY ? '' : 'Ventelisten får handle fra ' + L.fmtLong(open - L.EARLY) + '.';
            setText(S.clockNote, note);
            S.clockNote.hidden = !note;
          }
        }
      }
      if (S.overview) {
        var any = S.showProgress && (S.nUp + S.nRel > 0);
        S.overview.hidden = !any;
        if (S.chipUp) {
          show(S.chipUp, S.nUp > 0);
          setText(q(S.chipUp, '[data-chip-n]'), String(S.nUp));
        }
        if (S.chipRel) {
          show(S.chipRel, S.nRel > 0);
          setText(q(S.chipRel, '[data-chip-n]'), String(S.nRel));
        }
      }
    }

    /* ---------- KLOKKA ---------- */

    function tick(S) {
      if (!S.root._llks) return;
      var t = L.now();
      var prev = {};
      var changed = false;
      var access = L.hasAccess();
      if (access !== S.access) { S.access = access; changed = true; }
      S.cards.forEach(function (c) {
        prev[c.key] = c.state;
        if (stateOf(c, t) !== c.state) changed = true;
      });
      if (!changed && S.up.length && t >= S.up[0].open) changed = true;
      if (changed) regroup(S);
      S.cards.forEach(function (c) {
        var was = prev[c.key];
        renderCard(S, c, t);
        /* Etter at merket er byttet, så hengelåsen kan åpne seg. */
        if (was && was !== c.state && (c.state === 'open' || c.state === 'early') && (was === 'locked' || was === 'waitlist')) {
          celebrate(c);
        }
      });
      renderRows(S, t);
      renderHero(S, t);
    }

    /* Over 250 produkter i kilden: henter resten av sidene og legger kortene til. */
    function loadMore(S) {
      var pages = parseInt(S.root.getAttribute('data-pages'), 10) || 1;
      if (pages < 2 || !window.fetch || !window.DOMParser || !S.sectionId) return;
      var tasks = [];
      for (var p = 2; p <= Math.min(pages, 20); p++) {
        tasks.push(
          fetch(window.location.pathname + '?page=' + p + '&section_id=' + encodeURIComponent(S.sectionId), { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; })
        );
      }
      Promise.all(tasks).then(function (htmls) {
        var known = {};
        S.cards.forEach(function (c) { known[c.key] = true; });
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new window.DOMParser().parseFromString(html, 'text/html');
          each(doc.querySelectorAll('[data-ll-ks-card]'), function (fc) {
            var key = fc.getAttribute('data-key');
            if (known[key]) return;
            known[key] = true;
            var node = document.importNode(fc, true);
            S.pool.appendChild(node);
            var c = readCard(node);
            bindCard(S, c);
            S.cards.push(c);
          });
        });
        S.sig = null;
        regroup(S);
        tick(S);
      });
    }

    /* ---------- HANDLEKURV (smykker med én variant) ---------- */

    function firstAvailable(c) {
      for (var i = 0; i < c.variants.length; i++) if (c.variants[i].available) return c.variants[i];
      return null;
    }

    function addToCart(S, c) {
      var btn = c.addBtn;
      if (!btn || btn.disabled) return;
      var v = firstAvailable(c);
      if (!v) {
        setText(c.msg, 'Utsolgt.');
        return;
      }
      setText(c.msg, '');
      btn.disabled = true;
      btn.classList.add('is-loading');
      var finish = function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      };

      if (typeof L.onAdd === 'function') {
        L.onAdd(c, v, finish);
        return;
      }

      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      var drawer = document.querySelector((L.config && L.config.selDrawer) || 'cart-drawer');
      var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
      if (useDrawer) {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.section; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status) {
            setText(c.msg, (res && (res.description || res.message)) || 'Noe gikk galt. Prøv igjen.');
            return;
          }
          L.track('ll_kommer_snart_handlekurv', { ll_lansering: c.key });
          if (useDrawer && res.sections) drawer.renderContents(res);
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { setText(c.msg, 'Noe gikk galt. Prøv igjen.'); })
        .then(finish);
    }

    /* ---------- VENTELISTE ---------- */

    function openModal(S, ctx) {
      var m = S.modal;
      if (!m) return;
      S.ctx = ctx;
      if (ctx.all) {
        S.mProduct.hidden = true;
        setText(S.mTitle, S.allHeading);
        setText(S.mText, S.allText);
      } else {
        S.mProduct.hidden = false;
        if (ctx.thumb) {
          S.mThumb.src = ctx.thumb;
          S.mThumb.hidden = false;
        } else {
          S.mThumb.removeAttribute('src');
          S.mThumb.hidden = true;
        }
        setText(S.mName, ctx.title || '');
        setText(S.mWhen, ctx.when || '');
        setText(S.mTitle, S.heading);
        setText(S.mText, S.text);
      }
      S.tags.value = S.baseTags + (ctx.all ? ',kommer-alle' : ',kommer-' + ctx.key);
      setText(S.mError, ctx.error || '');
      S.submit.disabled = false;
      S.submit.classList.remove('is-loading');
      if (typeof m.showModal === 'function') {
        if (!m.open) m.showModal();
      } else {
        m.setAttribute('open', '');
        m.classList.add('is-fallback');
      }
      document.documentElement.classList.add('ll-ks-noscroll');
      window.setTimeout(function () {
        try { S.email.focus({ preventScroll: true }); } catch (e) { S.email.focus(); }
      }, 60);
    }

    function closeModal(S) {
      var m = S.modal;
      if (!m) return;
      if (typeof m.close === 'function') {
        if (m.open) m.close();
        if (typeof m.showModal === 'function') m.classList.remove('is-fallback');
      } else {
        m.removeAttribute('open');
      }
      document.documentElement.classList.remove('ll-ks-noscroll');
    }

    function toast(S, text) {
      if (!S.toast) return;
      setText(q(S.toast, 'p'), text);
      S.toast.hidden = false;
      window.clearTimeout(S.toastTimer);
      S.toastTimer = window.setTimeout(function () { S.toast.hidden = true; }, 8000);
    }

    function flashCard(S, key) {
      var c = null;
      S.cards.forEach(function (x) { if (x.key === key) c = x; });
      if (!c) return;
      window.setTimeout(function () {
        try { c.el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { c.el.scrollIntoView(); }
        c.el.classList.add('is-flash');
        window.setTimeout(function () { c.el.classList.remove('is-flash'); }, 2000);
      }, 250);
    }

    /* Shopify laster siden på nytt etter påmelding. Her plukker vi opp svaret. */
    function handlePosted(S) {
      var pending = L.ssGet(L.PENDING_KEY);
      if (!pending || Date.now() - (pending.t || 0) > 30 * MIN || (pending.src !== 'side' && pending.src !== 'hero')) return;
      var ok = !!q(S.root, '[data-form-ok]') || /[?&]customer_posted=true/.test(window.location.search);
      var err = !!q(S.root, '[data-form-error]');
      if (err && pending.src === 'hero' && S.hError) {
        setText(S.hError, (S.hError.textContent || '').replace(/\s+/g, ' ').trim() || 'Noe gikk galt. Prøv igjen.');
        window.setTimeout(function () {
          try { S.hEmail.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          try { S.hEmail.focus({ preventScroll: true }); } catch (e) {}
        }, 200);
        L.cleanPostedParam();
        return;
      }
      if (err) {
        openModal(S, {
          all: pending.key === '__all',
          key: pending.key,
          title: pending.title,
          when: pending.when,
          thumb: pending.thumb,
          error: (S.mError.textContent || '').replace(/\s+/g, ' ').trim() || 'Noe gikk galt. Prøv igjen.'
        });
        L.cleanPostedParam();
        return;
      }
      if (!ok) return;
      L.ssSet(L.PENDING_KEY, null);
      L.markJoined(pending.key);
      S.joined = L.joined();
      if (pending.key === '__all') {
        toast(S, 'Takk. Du får beskjed før hvert slipp.');
        heroJoined(S);
      } else {
        toast(S, 'Takk. Du står på ventelisten for ' + pending.title + '.');
        flashCard(S, pending.key);
      }
      L.cleanPostedParam();
    }

    /* Påmeldt til alle slipp: feltet i toppen byttes med en bekreftelse. */
    function heroJoined(S) {
      if (S.hWrap) S.hWrap.hidden = true;
      if (S.hDone) S.hDone.hidden = false;
    }

    /* Påmelding til alle slipp rett i toppen. Samme sjekk som i vinduet. */
    function bindHero(S) {
      if (!S.hSubmit || !S.hEmail) return;
      if (S.joined.indexOf('__all') !== -1) heroJoined(S);
      S.hSubmit.addEventListener('click', function (e) {
        if (!L.isEmail(S.hEmail.value)) {
          e.preventDefault();
          setText(S.hError, 'Skriv inn en gyldig e-postadresse.');
          S.hEmail.focus();
          return;
        }
        L.ssSet(L.PENDING_KEY, { key: '__all', title: '', when: '', thumb: '', src: 'hero', t: Date.now() });
        L.track('ll_kommer_snart_venteliste', { ll_lansering: 'alle', ll_kilde: 'kommer-snart-topp' });
        if (typeof L.onSubmit === 'function') {
          e.preventDefault();
          L.onSubmit({ all: true, src: 'hero' });
          return;
        }
        setText(S.hError, '');
        S.hSubmit.classList.add('is-loading');
      });
    }

    /* ---------- BINDING ---------- */

    function bindCard(S, c) {
      if (c.notifyBtn) {
        c.notifyBtn.addEventListener('click', function () {
          if (c.notifyBtn.disabled) return;
          openModal(S, {
            key: c.key,
            title: c.title,
            when: c.open ? L.cap('åpner for alle ' + L.fmtLong(c.open)) : '',
            thumb: c.thumb
          });
        });
      }
      if (c.addBtn) c.addBtn.addEventListener('click', function () { addToCart(S, c); });
    }

    function bindRoot(S) {
      var allBtn = q(S.root, '[data-notify-all]');
      if (allBtn) {
        allBtn.addEventListener('click', function () { if (!allBtn.disabled) openModal(S, { all: true }); });
        if (S.joined.indexOf('__all') !== -1) {
          allBtn.classList.add('is-joined');
          allBtn.disabled = true;
          allBtn.innerHTML = L.ICON_CHECK + '<span>Du får beskjed om alle slipp</span>';
        }
      }
      if (S.modal) {
        S.modal.addEventListener('click', function (e) { if (e.target === S.modal) closeModal(S); });
        S.modal.addEventListener('close', function () {
          if (!S.modal.open) document.documentElement.classList.remove('ll-ks-noscroll');
        });
        each(S.modal.querySelectorAll('[data-close]'), function (b) {
          b.addEventListener('click', function () { closeModal(S); });
        });
      }
      /*
        Sjekken skjer på klikket, før skjemaet sendes. Shopify legger en hCaptcha
        på kundeskjemaer, og den tar over selve innsendingen. Enter i feltet gir
        også et klikk på knappen.
      */
      if (S.submit && S.email) {
        S.submit.addEventListener('click', function (e) {
          if (!L.isEmail(S.email.value)) {
            e.preventDefault();
            setText(S.mError, 'Skriv inn en gyldig e-postadresse.');
            S.email.focus();
            return;
          }
          var ctx = S.ctx || { all: true };
          L.ssSet(L.PENDING_KEY, {
            key: ctx.all ? '__all' : ctx.key,
            title: ctx.title || '',
            when: ctx.when || '',
            thumb: ctx.thumb || '',
            src: 'side',
            t: Date.now()
          });
          L.track('ll_kommer_snart_venteliste', { ll_lansering: ctx.all ? 'alle' : ctx.key, ll_kilde: 'kommer-snart' });
          if (typeof L.onSubmit === 'function') {
            e.preventDefault();
            L.onSubmit(ctx);
            return;
          }
          setText(S.mError, '');
          S.submit.classList.add('is-loading');
          /*
            Et modalt vindu låser resten av siden. Da kan ingen trykke på en
            hCaptcha-test. Vinduet blir derfor vanlig (ikke modalt) mens skjemaet sendes.
          */
          var m = S.modal;
          if (m && m.open && typeof m.show === 'function' && !m.classList.contains('is-fallback')) {
            m.close();
            m.classList.add('is-fallback');
            m.show();
            document.documentElement.classList.add('ll-ks-noscroll');
          }
        });
      }
      if (S.toast) {
        var close = q(S.toast, '[data-toast-close]');
        if (close) close.addEventListener('click', function () { S.toast.hidden = true; });
      }
    }

    function readPart(root, name) {
      var el = q(root, '[data-part="' + name + '"]');
      return el ? { el: el, rows: q(el, '[data-rows]'), meta: q(el, '[data-part-meta]') } : null;
    }

    /* ---------- START ---------- */

    function init(root) {
      if (!root || root._llks) return;
      var modal = q(root, '[data-modal]');
      var S = {
        root: root,
        sectionId: root.getAttribute('data-section-id'),
        recentDays: parseFloat(root.getAttribute('data-recent-days')) || 7,
        unlockedDays: parseFloat(root.getAttribute('data-unlocked-days')) || 45,
        showNumbers: root.getAttribute('data-show-numbers') === 'true',
        showClock: root.getAttribute('data-show-clock') === 'true',
        showProgress: root.getAttribute('data-show-progress') === 'true',
        releasedFirst: root.getAttribute('data-released-first') === 'true',
        pool: q(root, '[data-pool]'),
        parts: { upcoming: readPart(root, 'upcoming'), released: readPart(root, 'released') },
        empty: q(root, '[data-empty]'),
        clock: q(root, '[data-clock]'),
        clockLabel: q(root, '[data-clock-label]'),
        clockWhen: q(root, '[data-clock-when]'),
        clockDrop: q(root, '[data-clock-drop]'),
        clockThumbs: q(root, '[data-clock-thumbs]'),
        clockNames: q(root, '[data-clock-names]'),
        clockNote: q(root, '[data-clock-note]'),
        clockKey: null,
        dd: q(root, '[data-dd]'),
        dh: q(root, '[data-dh]'),
        dm: q(root, '[data-dm]'),
        ds: q(root, '[data-ds]'),
        overview: q(root, '[data-overview]'),
        chipUp: q(root, '[data-chip="upcoming"]'),
        chipRel: q(root, '[data-chip="released"]'),
        modal: modal,
        form: modal ? q(modal, 'form') : null,
        email: modal ? q(modal, '[data-email]') : null,
        tags: modal ? q(modal, '[data-tags]') : null,
        submit: modal ? q(modal, '[data-submit]') : null,
        mError: modal ? q(modal, '[data-m-error]') : null,
        mTitle: modal ? q(modal, '[data-m-title]') : null,
        mText: modal ? q(modal, '[data-m-text]') : null,
        mProduct: modal ? q(modal, '[data-m-product]') : null,
        mThumb: modal ? q(modal, '[data-m-thumb]') : null,
        mName: modal ? q(modal, '[data-m-name]') : null,
        mWhen: modal ? q(modal, '[data-m-when]') : null,
        heading: modal ? modal.getAttribute('data-heading') : '',
        text: modal ? modal.getAttribute('data-text') : '',
        allHeading: modal ? modal.getAttribute('data-all-heading') : '',
        allText: modal ? modal.getAttribute('data-all-text') : '',
        toast: q(root, '[data-toast]'),
        hWrap: q(root, '[data-h-wrap]'),
        hEmail: q(root, '[data-h-email]'),
        hSubmit: q(root, '[data-h-submit]'),
        hError: q(root, '[data-h-error]'),
        hDone: q(root, '[data-h-done]'),
        access: L.hasAccess(),
        joined: L.joined(),
        cards: [],
        up: [],
        rel: [],
        times: [],
        nUp: 0,
        nRel: 0,
        sig: null
      };
      S.baseTags = S.tags ? (S.tags.getAttribute('data-base') || 'newsletter,kommer-snart') : 'newsletter,kommer-snart';
      root._llks = S;

      if (S.releasedFirst && S.parts.upcoming && S.parts.released) {
        S.parts.upcoming.el.parentNode.insertBefore(S.parts.released.el, S.parts.upcoming.el);
        if (S.chipUp && S.chipRel) S.chipUp.parentNode.insertBefore(S.chipRel, S.chipUp);
      }

      if (S.pool) {
        each(S.pool.querySelectorAll('[data-ll-ks-card]'), function (el) {
          var c = readCard(el);
          bindCard(S, c);
          S.cards.push(c);
        });
      }
      bindRoot(S);
      bindHero(S);

      if (S.pool && S.parts.upcoming && S.parts.released) {
        S.pool.hidden = true;
        regroup(S);
        tick(S);
      }
      root.classList.add('is-ready');
      handlePosted(S);
      loadMore(S);

      L.syncClock(function () { tick(S); });
      S.timer = window.setInterval(function () { if (!document.hidden) tick(S); }, 1000);
      S.onVisible = function () { if (!document.hidden) tick(S); };
      document.addEventListener('visibilitychange', S.onVisible);
      S.destroy = function () {
        window.clearInterval(S.timer);
        window.clearTimeout(S.toastTimer);
        document.removeEventListener('visibilitychange', S.onVisible);
        root._llks = null;
      };
    }

    return { init: init, tick: function (root) { if (root && root._llks) tick(root._llks); } };
  }
})();
